import React from 'react';
import { BillingPortalStateContext } from '../providers/BillingPortalStateProvider';
import type { MaintenanceWindowDto } from '@zg-rentals/ts-adproducts-client';
import { AdproductsUserBillingInvoiceApiHandler_getMaintenanceWindow } from '@zg-rentals/ts-adproducts-client';

export interface BillingPortalMaintenanceStateType {
  billingPortalMaintenance: MaintenanceWindowDto | null;
  billingPortalMaintenanceChecked: boolean;
  isMaintenanceMode: boolean;
}

const DEFAULT_STATE: BillingPortalMaintenanceStateType = {
  billingPortalMaintenance: null,
  billingPortalMaintenanceChecked: false,
  isMaintenanceMode: false,
};

export interface UserMaintenanceProps {
  userIsGuest?: boolean;
}

export const useMaintenance = ({ userIsGuest }: UserMaintenanceProps = {}) => {
  const [billingPortalMaintenance, setBillingPortalMaintenance] =
    React.useState<BillingPortalMaintenanceStateType>(DEFAULT_STATE);

  React.useEffect(() => {
    if (userIsGuest) return;
    AdproductsUserBillingInvoiceApiHandler_getMaintenanceWindow()
      .then((maintenance) => {
        let isMaintenanceMode = false;
        if (maintenance && maintenance.left) {
          isMaintenanceMode = new Date().getTime() > maintenance.left.seconds * 1000;
        }
        return setBillingPortalMaintenance((state) => ({
          ...state,
          billingPortalMaintenance: maintenance,
          billingPortalMaintenanceChecked: true,
          isMaintenanceMode,
        }));
      })
      .catch(() => {
        return setBillingPortalMaintenance((state) => ({
          ...state,
          billingPortalMaintenanceChecked: true,
          isMaintenanceMode: false,
        }));
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  return {
    billingPortalMaintenance,
    setBillingPortalMaintenance,
  };
};

export const useAppMaintenance = () => {
  const billingPortalState = React.useContext(BillingPortalStateContext);

  if (!billingPortalState) throw new Error('State Not initialized');

  return React.useMemo(() => billingPortalState.maintenance.billingPortalMaintenance, [billingPortalState.maintenance]);
};
